export enum AutoplayMode {
  Unset,
  Playing,
  Pausing,
}
